<div>
  <div class="row">
    @if (ndeLinkFromQMDB.length == 0) {
      <div>
        You're about to process <span style="font-weight: bold">{{ selectedLogs.length }} {{ selectedLogs.length <= 1 ? 'log' : 'logs' }}</span>
      </div>
    }
  </div>

  @if (ndeFlag == false) {
    <div>
      <div style="font-weight: bold">NDE submitted failed!</div>
    </div>
  }
  @if (ndeFlag == true) {
    <div>
      <div style="font-weight: bold">NDE submitted successfully!</div>
    </div>
  }

  <div class="row">
    <div class="col-12 buttons-padding" style="display: table">
      @if (formSubmitted == false) {
        <div>
          <p-button (onClick)="cancel()" class="red-btn mt-4 action-btn"><em class="pi pi-times-circle mr-2"></em>Cancel</p-button>
        </div>
      }
      @if (formSubmitted == true) {
        <div>
          <p-button (onClick)="cancel()" class="mt-4 mr-2 action-btn"><em class="pi pi-times-circle mr-2"></em>Close</p-button>
        </div>
      }
      <p-button class="mt-4 mr-2 action-btn" (onClick)="submitNewLog()" [disabled]="formSubmitted">Submit NDEs</p-button>
    </div>
  </div>
</div>

